import React from "react";

const HomeFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      className="text-center p-3"
      style={{
        backgroundColor: "rgba(0,0,0,0.05)",
        position: "relative",
        zIndex: 10,
      }}
    >
      <p style={{ marginTop: "10px", fontSize: "16px" }}>
        © {year}{" "}
        <a
          href="https://aawsoft.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          AAWSoft Solutions
        </a>
        . All rights reserved.
      </p>
    </footer>
  );
};

export default HomeFooter;
